import React, { Component } from "react";
import clientX from "../../../utils/clientX";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import billPayClientX from "../../../utils/api/billPayClientX";
import client from "../../../utils/client";
import { connect } from "react-redux";
import { setRepeatData } from "../actions/order";
import classNames from "classnames";
import icRow from "../../../assets/orders/ic_arrow.png"
import Lottie from "lottie-react";
import EarnReward from "../../../assets/orders/ic_trophy.json";
import EarnedReward from "../../../assets/orders/ic_won_cash.json";
class OrderDetail extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      order: null,
      isLoading: false,
      canDownloadReceipt: false,
    };
  }

  downloadReceipt = () => {
    const orderID = this.state.order.id;
    billPayClientX.get(`/v1/order/${orderID}/receipt`).then((response) => {
      window.open(response.data.data.receipt);
    });
  };

  repeat = () => {
    const item = this.state.order;
    client.get(`v1/bill-pay/services`).then((response) => {
      const data = response.data.data;
      data.map(service => {
        if (service.name === item.service_name) {
          this.props.repeat(item);
          this.props.history.push(`/bill-pay/${service.id}`);
        }
        return null
      })
    });
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidMount() {
    this.props.repeat(null);

    this._isMounted = true;

    const {
      match: { params },
    } = this.props;

    clientX.get(`v1/bill-pay/${params.id}`).then((response) => {
      if (this._isMounted) {
        let data = response.data.data;

        this.setState({
          order: data,
        });
        if (3 === parseInt(data.status)) {
          this.setState({
            canDownloadReceipt: true,
          });
        }
        if (
          2 === parseInt(data.status) ||
          4 === parseInt(data.status) ||
          5 === parseInt(data.status) ||
          7 === parseInt(data.status)
        ) {
          this.setState(
            {
              isLoading: true,
            },
            () => {
              setTimeout(() => {
                clientX.get(`v1/bill-pay/${params.id}`).then((response) => {
                  let data = response.data.data;
                  this.setState({
                    order: data,
                    isLoading: false,
                  });
                });
              }, 30000);
            }
          );
        }
      }
    });
  }

  viewInvoice = (url) => {
    window.open(url);
  };

  Shimmer = (props) => {
    return (
      <div className="container-fluid py-3 py-md-5">
        <div className="row">
          <div className="col-12 col-md-6 offset-md-3">
            <div className="box shine box-voucher-detail-logo"></div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { order, canDownloadReceipt } = this.state;
    return (
      order === null ?
        <this.Shimmer />
        :
        null !== order && (
          <div className="container-fluid">
            <div className="row mt-3 mb-3 mt-md-4 mb-md-4 align-items-center">
              <div className="col-12 text-md-center">
                <small>
                  <Link to="/">
                    <FormattedMessage
                      id="breadcrumbs.home"
                      defaultMessage="Home"
                    />
                  </Link>
                </small>{" "}
                /{" "}
                <small>
                  <Link to="/orders">
                    <FormattedMessage id="navbar.orders" />
                  </Link>
                </small>{" "}
                /{" "}
                <small>
                  <strong>
                    <FormattedMessage id="orders.order" />
                  </strong>
                </small>
              </div>
            </div>

            <div className="row mb-3 mb-md-4">
              <div className="col-12 col-md-6 offset-md-3">
                <div className="list-group">
                  <div className="list-group-item list-group-item-action">
                    <p className="d-inline mb-0">
                      <FormattedMessage id="order.number" />{" "}
                      <strong>{order.number}</strong>
                    </p>
                  </div>
                  <div className="list-group-item list-group-item-action">
                    <div className="row align-items-center">
                      <div className="col-12 col-md-6">
                        <OrderStatusLabel
                          order={order}
                          {...this.state}
                        />
                      </div>
                      <div className="col-12 col-md-6 text-md-right">
                        <p className="mb-0">
                          <FormattedMessage id="orders.your-order-number-is" />{" "}
                          <strong>{order.order_number}</strong>
                        </p>
                        <p className="mb-0">{order.created_at}</p>
                      </div>
                    </div>
                  </div>
                  <div className="list-group-item list-group-item-action">
                    <p className="mb-0">
                      <>
                        <PaymentStatusLabel order={order} />
                      </>
                    </p>
                  </div>
                  <div className="list-group-item list-group-item-action">
                    <p className="mb-0">
                      <strong>{order.wrp}</strong> WRP{" "}
                      {order.wrp_credited ? "credited" : "are pending"}
                    </p>
                  </div>
                </div>
                <div className="display-btns-wrapper">
                  {/* add enlarge-btn to increase width */}
                  <div
                    className={classNames("btn-wrapper", {
                      "enlarge-btn": !order.invoice_url,
                      "disable-btn": !canDownloadReceipt,
                    })}
                  >
                    {canDownloadReceipt && (
                      <button
                        className="btn btn-outline-primary btn-block mt-3 home-btn"
                        onClick={this.downloadReceipt}
                      >
                        <FormattedMessage
                          id="general.download-receipt"
                          defaultMessage="Download Receipt"
                        />
                      </button>
                    )}
                  </div>
                  <div
                    className={classNames("btn-wrapper", {
                      "enlarge-btn": !canDownloadReceipt,
                      "disable-btn": !order.invoice_url,
                    })}
                  >
                    {order.invoice_url && (
                      <button
                        className="btn btn-outline-primary btn-block mt-3 home-btn"
                        onClick={() =>
                          this.viewInvoice(order.invoice_url)
                        }
                      >
                        <FormattedMessage
                          id="order.view-invoice"
                          defaultMessage="View Invoice"
                        />
                      </button>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    {order.can_repeat_order && (
                      <button
                        className="btn btn-outline-primary btn-block mt-3 home-btn"
                        onClick={this.repeat}
                      >
                        <FormattedMessage
                          id="billpay.repeat"
                          defaultMessage="Repeat"
                        />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {order.won_reward === false ?
              null :
              order.rewards_cliamed === false ?
                claimNow(order) : claimed(order)
            }

          </div>
        )
    );
  }
}

const claimNow = (order) => {
  return (
    <div className="row mb-3 mb-md-4 ">
      <div className="col-md-6 offset-md-3">
        <Link to="/rewards">
          <div className="row mb-4 order-reward-earned">
            <div className="col-9 centered">
              <h3>You have earned the reward on this transaction!</h3>
              <span className="flex-icon">CLAIM NOW
                <img style={{ marginLeft: "5px" }} src={icRow} alt="arrow" width="30px" />
              </span>
            </div>
            <div className="col-3">
              <Lottie animationData={EarnReward} loop={true} width="50" />
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
}

const claimed = (order) => {
  return (
    <div className="row mb-3 mb-md-4 ">
      <div className="col-md-6 offset-md-3">
        <Link to="/rewards">
          <div className="row mb-4 order-reward-earned">
            <div className="col-9 centered">
              <h3>You have won {order.reward_label} as Rewards for this transaction!</h3>
            </div>
            <div className="col-3">
              <Lottie animationData={EarnedReward} loop={true} width="50" />
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
}

// const winCash = (order) => {
//   return (
//     <div className="row mb-3 mb-md-4 ">
//       <div className="col-md-6 offset-md-3">
//         <Link to="/rewards">
//           <div className="row mb-4 order-reward-cash">
//             <div className="col-9 centered">
//               <h3>Spend Rs. 100 or more on WINDS and win cash & WRP as Rewards</h3>
//             </div>
//             <div className="col-3">
//             </div>
//           </div>
//         </Link>
//       </div>
//     </div>
//   )
// }


const mapDispatchToProps = (dispatch) => {
  return {
    repeat: (repeatData) => {
      dispatch(setRepeatData(repeatData));
    },
  };
};

export default connect(null, mapDispatchToProps)(OrderDetail);

function PaymentStatusLabel(props) {
  const status = props.order.status;
  switch (status) {
    case 0:
      return (
        <React.Fragment>
          <FormattedMessage
            id="order.payment-of-rs"
            defaultMessage="Payment of Rs."
          />{" "}
          <strong>{props.order.amount}</strong>{" "}
          <FormattedMessage
            id="order.payment-pending"
            defaultMessage="is Pending"
          />
        </React.Fragment>
      );
    case 1:
    case 2:
      return (
        <React.Fragment>
          <FormattedMessage
            id="order.payment-of-rs"
            defaultMessage="Payment of Rs."
          />{" "}
          <strong>{props.order.amount}</strong>{" "}
          <FormattedMessage
            id="order.payment-pending"
            defaultMessage="is Pending"
          />
        </React.Fragment>
      );
    case 8:
      return (
        <React.Fragment>
          <FormattedMessage
            id="order.payment-of-rs"
            defaultMessage="Payment of Rs."
          />{" "}
          <strong>{props.order.amount}</strong>{" "}
          <FormattedMessage
            id="order.payment-failed"
            defaultMessage="is Failed"
          />
        </React.Fragment>
      );
    default:
      return (
        <React.Fragment>
          <FormattedMessage
            id="order.payment-of-rs"
            defaultMessage="Payment of Rs."
          />{" "}
          <strong>{props.order.amount}</strong>{" "}
          <FormattedMessage
            id="order.payment-success"
            defaultMessage="is Successful"
          />
        </React.Fragment>
      );
  }
}

function OrderStatusLabel(props) {
  if (props.isLoading) {
    return (
      <p className="badge badge-warning text-white blinking mb-0">
        <FormattedMessage id="order.processing" defaultMessage="Processing" />
      </p>
    );
  }

  if (props.order.fulfilled) {
    return (
      <p className={classNames("badge badge-success", "text-white", "mb-0")}>
        {props.order.status_text_translated}
      </p>
    );
  }

  if (!props.order.fulfilled && props.order.payment_failed) {
    return (
      <p className={classNames("badge badge-danger", "text-white", "mb-0")}>
        {props.order.status_text_translated}
      </p>
    );
  }

  return (
    <p className={classNames("badge badge-warning", "text-white", "mb-0")}>
      {props.order.status_text_translated}
    </p>
  );
}
